import RoutesGeneral from './modules/general'
import RoutesChecklist from './modules/checklist'
import RoutesProduction from './modules/core'
import RoutesERP from './modules/erp'
import RoutesCustom from './modules/custom'


//Telas que não necessitam esta logado (raiz)
const Login = () => import('../views/Login')
const Recovery = () => import('../views/Recovery')
const ReportByPartPublic = () => import('../views/ReportByPartPublic')
const ReportByPartPublicFiles = () => import('../views/ReportByPartPublicFiles')
const ReportView = () => import('@/views/modules/ReportViewByGeneral.vue')
const Default = () => import('../views/Default')


//Checklist reports View (Copiar para Word)
const ChecklistViewReportChecklistEvidence  = () => import('@/views/modules/checklist/Report/ReportPhotoChecklistEvidenceView.vue')

let routes = RoutesGeneral

if (localStorage.getItem('account')) {

    const account = JSON.parse(localStorage.getItem('account'))
    let removeByCustom = []

    if (account.module === 'production')
        routes = routes.concat(RoutesProduction)

    if (account.module === 'arch' || account.module === 'estate' || account.module === 'condo')
        routes = routes.concat(RoutesChecklist)

    //if (account.module === 'erp') {
    //Por enquanto o módulo de produção é o único que poderá ser vendido com ERP
    routes = routes.concat(RoutesERP)
    //}

    if (account.custom) {
        routes = routes.concat(RoutesCustom.routes)
        removeByCustom = RoutesCustom.remove
    }


    for (const remove of removeByCustom) {
        const indexRemove = routes.findIndex(a => a.name === remove)

        if (indexRemove >= 0)
            routes.splice(indexRemove, 1)

    }


}


export default [
    {
        path: '/login',
        component: Login,
        name: 'login'
    },
    {
        path: '/recovery',
        component: Recovery,
        name: 'recovery'
    },
    {
        path: '/r/:tokenReport',
        component: ReportByPartPublic,
        name: 'report-by-part-public'
    },
    {
        path: '/r/:tokenReport/:tokenDownload',
        component: ReportByPartPublicFiles,
        name: 'report-by-part-public-files'
    },
    {
        path: '/report-view',
        component: ReportView,
        name: 'report-view'
    },
    {
        path: '/checklist/report/view/checklist-evidence',
        name: 'checklist-report-view-checklist-evidence',
        component: ChecklistViewReportChecklistEvidence
    },
    {
        path: '/',
        component: Default,
        name: 'default',
        meta: {requiresAuth: true},
        props: true,
        children: routes
    },
    {
        path: '*',
        redirect: '/'
    }

]